var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .667a8.333 8.333 0 00-6.125 13.966 8.334 8.334 0 0012.25 0A8.334 8.334 0 009 .667zm0 15a6.667 6.667 0 01-4.625-1.876 5 5 0 019.25 0A6.667 6.667 0 019 15.666zM7.333 7.332a1.667 1.667 0 113.334 0 1.667 1.667 0 01-3.334 0zm7.425 5A6.666 6.666 0 0011.5 9.517a3.333 3.333 0 10-5 0 6.666 6.666 0 00-3.258 2.816A6.6 6.6 0 012.333 9a6.667 6.667 0 1113.334 0 6.6 6.6 0 01-.909 3.333z",
    fill: "#8A9AA7"
  })));
}
export default SvgUserRound;